import { UrgencyTier } from '@/sections/customerManagement/types/dogPile.types';

export interface UrgencyTableEntry {
  maxDays: number;
  multiplier: number;
  tier: UrgencyTier;
}

/** Urgency multipliers for subscription-type customers (MANAGED/SAAS) */
export const SUBSCRIPTION_URGENCY_TABLE: readonly UrgencyTableEntry[] = [
  { maxDays: 90, multiplier: 4.0, tier: 'CRITICAL' },
  { maxDays: 180, multiplier: 3.0, tier: 'HIGH' },
  { maxDays: 270, multiplier: 1.8, tier: 'MODERATE' },
  { maxDays: Infinity, multiplier: 1.0, tier: 'HEALTHY' },
] as const;

/** Urgency multipliers for project-type customers (PILOT/ENGAGEMENT) */
export const PROJECT_URGENCY_TABLE: readonly UrgencyTableEntry[] = [
  { maxDays: 7, multiplier: 4.0, tier: 'CRITICAL' },
  { maxDays: 14, multiplier: 3.0, tier: 'HIGH' },
  { maxDays: 28, multiplier: 2.0, tier: 'MODERATE' },
  { maxDays: Infinity, multiplier: 1.0, tier: 'HEALTHY' },
] as const;

/** Urgency multipliers for freemium customers (FREEMIUM) — max tier is HIGH, no CRITICAL */
export const FREEMIUM_URGENCY_TABLE: readonly UrgencyTableEntry[] = [
  { maxDays: 90, multiplier: 2.5, tier: 'HIGH' },
  { maxDays: 180, multiplier: 1.5, tier: 'MODERATE' },
  { maxDays: Infinity, multiplier: 1.0, tier: 'HEALTHY' },
] as const;

/** Multiplier applied to expired customers' priority score */
export const EXPIRED_MULTIPLIER = 1.5;

/** Customer types that map to subscriptions category */
export const SUBSCRIPTION_TYPES = ['MANAGED', 'SAAS'] as const;

/** Customer types that map to freemium category */
export const FREEMIUM_TYPES = ['FREEMIUM'] as const;

/** Customer types that map to projects category */
export const PROJECT_TYPES = ['PILOT', 'ENGAGEMENT'] as const;
